<table #outerSort="matSort" mat-table [dataSource]="dataSource" multiTemplateDataRows matSort>
  <ng-container matColumnDef="{{column.property}}" *ngFor="let column of columnsToDisplay">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.name}} </th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'td-expanded fw-bold--500': element == expandedElement}">
      <ng-container *ngIf="column.property !== 'toggle'">
        <ng-container *ngIf="!tableRowTemplate">
          {{element[column.property]}}
        </ng-container>

        <ng-container *ngIf="tableRowTemplate" [ngTemplateOutlet]="tableRowTemplate"
          [ngTemplateOutletContext]="{$implicit:element, property:column.property}">
        </ng-container>
      </ng-container>

      <ng-container *ngIf="column.property === 'toggle'">
        <button mat-icon-button (click)="toggleRow(element)">
          <mat-icon class="mat-icon--secondary" *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
          <mat-icon class="mat-icon--secondary" *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
        </button>
      </ng-container>
    </td>
  </ng-container>


  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length"
      [ngClass]="{'td-expanded': element == expandedElement}">
      <div class="element-detail" *ngIf="element[expandedKey].data.length"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
        <div class="inner-table" *ngIf="expandedElement">
          <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="{{'common.filter' | translate}}">
          </mat-form-field>
          <table id="childTable" #innerTables mat-table #innerSort="matSort" [dataSource]="element[expandedKey]"
            matSort>
            <ng-container matColumnDef="{{innerColumn.property}}" *ngFor="let innerColumn of innerDisplayedColumns">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{innerColumn.name}} </th>
              <td mat-cell *matCellDef="let element">

                <ng-container *ngIf="!innerTableRowTemplate">
                  {{element[innerColumn.property]}}
                </ng-container>

                <ng-container *ngIf="innerTableRowTemplate" [ngTemplateOutlet]="innerTableRowTemplate"
                  [ngTemplateOutletContext]="{$implicit:element, property:innerColumn.property}">
                </ng-container>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedInner"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedInner;"></tr>
          </table>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let element; columns: displayedColumns;"
    [class.element-row]="element[expandedKey].data.length" [class.expanded-row]="expandedElement === element">
  </tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
</table>
